import { render, staticRenderFns } from "./MoleculeImageInfo.vue?vue&type=template&id=57296028&scoped=true&"
import script from "./MoleculeImageInfo.vue?vue&type=script&lang=js&"
export * from "./MoleculeImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeImageInfo.vue?vue&type=style&index=0&id=57296028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57296028",
  null
  
)

export default component.exports